export default __webpack_public_path__ + "static/media/04_vote.d3d3dba3.mp3";